import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { JsonSchema, JsonSchemaBase, JsonSchemaCore, JsonSchemaObject } from 'lib/json-schema';

export interface FunctionJsonSchema extends JsonSchemaObject {
  properties: {
    parameterTypes: JsonSchemaObject<FunctionParameterJsonSchema>;
    returnType: FunctionReturnTypeJsonSchema;
  };
  function: boolean;
}

interface GenericType extends JsonSchemaBase {
  genericType: string;
}

export type FunctionParameterJsonSchema = (JsonSchemaCore | GenericType) & { position: number };

export type FunctionReturnTypeJsonSchema = JsonSchema | GenericType;

export interface ObjectSchemaMap {
  [$ref: string]: JsonSchemaObject<JsonSchema | FunctionJsonSchema>;
}

export interface State {
  objectSchemaMap: ObjectSchemaMap;
}

const initialState: State = {
  objectSchemaMap: {},
};

// object schemas are global across an organization
const { reducer, actions } = createSlice({
  name: 'objectSchemas',
  initialState,
  reducers: {
    addObjectSchemas: (state, action: PayloadAction<ObjectSchemaMap>) => {
      Object.assign(state.objectSchemaMap, action.payload);
    },
  },
});

export const { addObjectSchemas } = actions;
export const objectSchemasReducer = reducer;
